export default __webpack_public_path__ + "static/media/icomoon.c3ca4bb2.woff";